{
  "name": "luv-product-portal",
  "version": "2026.43.1",
  "private": true,
  "type": "module",
  "scripts": {
    "app:serve": "vite --host",
    "app:build": "run-p type-check \"build-only {@}\" --",
    "preview": "vite preview",
    "build-only": "vite build",
    "type-check": "vue-tsc --build --force",
    "lint": "eslint . --fix",
    "lint:ci": "eslint . --format junit --output-file test-reports/eslint.xml",
    "test": "vitest run",
    "test:hook": "vitest run --reporter=minimal",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "start": "docker compose up -d",
    "stop": "docker compose down",
    "restart": "npm run stop && npm run start",
    "logs": "docker compose logs autoq --follow",
    "create-certs-dir": "mkdir -p ./docker/certs",
    "create-certs": "npm run create-certs-dir && openssl req -x509 -nodes -days 365 -newkey rsa:2048 -keyout ./docker/certs/autoq-cert.key -out ./docker/certs/autoq-cert.crt -subj /C=DE/ST=Hamburg/L=Hamburg/O=\"polargold GmbH\"/OU=IT",
    "setup": "npm run create-certs && npm i && cp example.env .env",
    "prepare": "husky"
  },
  "dependencies": {
    "@fortawesome/fontawesome-free": "^7.3.1",
    "@polargold/luv-ui-library": "^2.7.2",
    "@polargold/pg-frontend-core": "^0.5.0",
    "@polargold/pg-frontend-vue": "^0.5.0",
    "@sentry/vite-plugin": "^11.9.0",
    "@vuelidate/core": "^2.0.3",
    "@vuelidate/validators": "^2.0.4",
    "axios": "^1.20.0",
    "joi": "^18.2.9",
    "lodash": "^4.18.1",
    "pinia": "^4.0.3",
    "vue": "^3.5.43",
    "vue-router": "^5.4.0"
  },
  "devDependencies": {
    "@intlify/eslint-plugin-vue-i18n": "^4.5.1",
    "@pinia/testing": "^2.0.1",
    "@sentry/vue": "^11.6.0",
    "@stylistic/eslint-plugin": "^5.10.0",
    "@tailwindcss/postcss": "^4.3.3",
    "@tsconfig/node20": "^20.1.10",
    "@types/lodash": "^4.17.26",
    "@types/node": "^24.19.2",
    "@vitejs/plugin-vue": "^6.0.10",
    "@vitest/coverage-v8": "^5.0.3",
    "@vue/eslint-config-typescript": "^14.9.0",
    "@vue/test-utils": "^2.5.1",
    "@vue/tsconfig": "^0.9.1",
    "eslint": "^10.12.0",
    "eslint-formatter-junit": "^9.0.1",
    "eslint-plugin-vue": "^10.11.1",
    "husky": "^9.1.7",
    "jsdom": "^30.1.2",
    "npm-run-all2": "^9.0.3",
    "postcss": "^8.5.29",
    "tailwindcss": "^4.0.0",
    "typescript": "^5.9.3",
    "vite": "^8.3.4",
    "vitest": "^5.0.3",
    "vue-i18n": "^11.4.14",
    "vue-tsc": "^3.3.13"
  }
}
